// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1jy-T","content":"styles_content__Sg3MN","selectAll":"styles_selectAll__jbZUq"};